import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Prohibit, ArrowCounterClockwise, ShieldCheck, Trash, Megaphone, ClipboardText } from "@phosphor-icons/react";
import { format } from "date-fns";

const ICONS = {
  suspend: Prohibit, unsuspend: ArrowCounterClockwise, change_role: ShieldCheck,
  delete_user: Trash, announcement_send: Megaphone,
};
const COLORS = {
  suspend: "text-destructive", unsuspend: "text-emerald-400", change_role: "text-primary",
  delete_user: "text-destructive", announcement_send: "text-amber-400",
};

export default function AdminAudit() {
  const { data: logs = [] } = useQuery({
    queryKey: ["admin-audit"],
    queryFn: async () => (await api.get("/admin/audit")).data,
  });

  return (
    <div data-testid="admin-audit-page">
      <p className="text-sm text-muted-foreground mb-4">Last 100 admin actions.</p>
      <Card className="bg-card border-border overflow-hidden">
        {logs.length === 0 && <div className="p-8 text-center text-muted-foreground">No audit entries yet.</div>}
        {logs.map((l) => {
          const Icon = ICONS[l.action] || ClipboardText;
          return (
            <div key={l.id} data-testid={`audit-row-${l.id}`}
              className="flex items-center gap-3 px-4 py-3 border-b border-border last:border-0">
              <div className={`h-8 w-8 rounded-md bg-secondary flex items-center justify-center shrink-0 ${COLORS[l.action] || "text-muted-foreground"}`}>
                <Icon className="h-4 w-4" weight="bold" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm">
                  <span className="font-semibold">{l.admin_email}</span>{" "}
                  <span className="text-muted-foreground">{l.action.replace(/_/g, " ")}</span>
                  {l.target_email && <> → <span className="font-medium">{l.target_email}</span></>}
                  {l.details?.new_role && <span className="text-muted-foreground"> ({l.details.new_role})</span>}
                  {l.details?.title && <span className="text-muted-foreground"> "{l.details.title}" → {l.details.recipients} recipient(s)</span>}
                </p>
              </div>
              <span className="text-xs text-muted-foreground shrink-0">{l.timestamp ? format(new Date(l.timestamp), "MMM d, h:mm a") : ""}</span>
            </div>
          );
        })}
      </Card>
    </div>
  );
}
